import { render, staticRenderFns } from "./MoLayout.vue?vue&type=template&id=542b977f&scoped=true&"
import script from "./MoLayout.vue?vue&type=script&lang=js&"
export * from "./MoLayout.vue?vue&type=script&lang=js&"
import style0 from "./MoLayout.vue?vue&type=style&index=0&lang=less&"
import style1 from "./MoLayout.vue?vue&type=style&index=1&id=542b977f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542b977f",
  null
  
)

export default component.exports